<h3>{{ isFormEnabled ? "Enter Search Criteria" : "Search Criteria Review" }}</h3>
<div class="padding">
    <form [formGroup]="searchCriteriaDetails">
        <div class="flex-container">
            <div class="validated-form-field-container flex-container">
                <mat-form-field class="flex-item form-field" appearance="outline">
                    <mat-label>{{ 'common.labels.registrationNumber' | transloco }}</mat-label>
                    <input matInput [formControlName]="'registrationNumber'" name="registration-number" [placeholder]="'common.labels.registrationNumber' | transloco">
                </mat-form-field>
                <lib-error-bubble [control]="searchCriteriaDetails.get('registrationNumber')!"
                    [message]="registrationNumberError$"></lib-error-bubble>
            </div>
        </div>

        <!-- <mat-expansion-panel *ngIf="shouldDisplaySearchFromDate"
            [expanded]="shouldExpandAdditionalParameters()" (click)="this.hasUserExpandedAdditionalParameters = true"
            [class.mat-elevation-z1]="!panel.expanded" [class.mat-elevation-z0]="panel.expanded"
            #panel="matExpansionPanel">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4>Additional Parameters</h4>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div *ngIf="shouldDisplaySearchFromDate" class="flex-container">
                <div class="validated-form-field-container flex-container">
                    <mat-form-field class="form-field flex-item" appearance="outline">
                        <mat-label>Exclude Registrations Previous To</mat-label>
                        <input matInput [matDatepicker]="searchFromDate" [formControlName]="'searchFromDate'"
                            name="search-from-date" placeholder="YYYY-MM-DD">
                        <mat-datepicker-toggle matSuffix [for]="searchFromDate"></mat-datepicker-toggle>
                        <mat-datepicker #searchFromDate></mat-datepicker>
                    </mat-form-field>
                    <lib-error-bubble [control]="searchCriteriaDetails.get('searchFromDate')!"
                        [message]="searchFromDateError$"></lib-error-bubble>
                </div>
            </div>
            <br />
            <br />
        </mat-expansion-panel> -->
    </form>
</div>